<template>
    <div class="help-line">
        <div class="content">
            <div class="node">
                <div class="top">
                    <ul>
                        <template v-for="(item, index) in list">
                            <li
                                v-if="item.position === 'top'"
                                :key="index"
                                :class="{ cur: current === index }"
                                :style="{ marginLeft: item.marginLeft }"
                                @click="tabClick(index)"
                            >
                                {{ item.nav }}
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="xian">
                    <img src="/images/help/line.png" alt="" />
                </div>
                <div class="bottom">
                    <ul>
                        <template v-for="(item, index) in list">
                            <li
                                v-if="item.position === 'bottom'"
                                :key="index"
                                :class="{ cur: current === index }"
                                :style="{ marginLeft: item.marginLeft }"
                                @click="tabClick(index)"
                            >
                                {{ item.nav }}
                            </li>
                        </template>
                    </ul>
                </div>
            </div>

            <el-card class="detail">
                <div class="body">
                    <div class="left">
                        <img :src="currentDetail.imgUrl" />
                    </div>
                    <div class="right" v-html="currentDetail.content"></div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            current: 0,
            list: [
                {
                    nav: "注册",
                    position: "top",
                    marginLeft: "40px",
                    imgUrl: "/images/help/d-reg.png",
                    content: `
                    <h2>注册页面的注意事项：</h2>
                    <p>1、支持谷歌、360安全浏览器，推荐使用谷歌浏览器。</p>
                    <p>2、用户类型，若以单位性质投标，请选择<b>【单位】</b>。</p>
                    <p>3、注册角色，若是投标请选择<b>【投标人】</b>。</p>
                    <p>4、注册人姓名，谁注册即填写谁的姓名。</p>
                    <p>5、登录名或登录密码，请勿含有特殊符号和空格。</p>
                    <p>6、此页面手机号请牢记，若登录名、密码忘记，可通过该手机号找回。</p>
                    `,
                },
                {
                    nav: "登录",
                    position: "bottom",
                    marginLeft: "140px",
                    imgUrl: "/images/help/d-login.png",
                    content: `
                    <h2>登录页面的注意事项：</h2>
                    <p>1、请选择与注册时对应的身份进行登录。</p>
                    <p>2、密码或CA登录后均可下载招标文件。</p>
                    <p>3、提示用户名或密码错误，请通过【忘记登录名】【忘记密码】分别找回。</p>
                    <p>4、若注册人已离职，不知道账号密码，请通过【手机号不在使用】找回。</p>
                    <p>5、若采用CA登录，请务必将CA与账号进行绑定，否则无法登录。</p>
                    `,
                },
                {
                    nav: "CA办理及绑定",
                    position: "top",
                    marginLeft: "145px",
                    imgUrl: "/images/help/d-ca.png",
                    content: `
                    <h2>办理及绑定CA的注意事项：</h2>
                    <p>1、线上申请：点击【CA在线办理】，过程中有疑问请咨询河北CA客服热线400-707-3355。</p>
                    <p>2、绑定CA三部曲：第一、注册惠智采账号。第二、使用账号密码登录。第三、【系统管理】-【人员管理/职业人员】点击【绑定CA】。</p>
                    `,
                },
                {
                    nav: "报名购标",
                    position: "bottom",
                    marginLeft: "160px",
                    imgUrl: "/images/help/d-sign.png",
                    content: `
                    <h2>报名购标的注意事项：</h2>
                    <p>1、需报名，使用账号密码或CA登录，到【报名/文件下载】，点击【报名】，按要求上传报名资料后，等待招标代理机构审核（联系方式见招标公告底部），审核结果可关注【报名情况查看】。</p>
                    <p>2、无需报名-无需购标，点击【查看采购文件】，到【我参与的项目】-进入流程，可直接下载招标文件。</p>
                    <p>3、无需报名-需购标，点击【购标】，到【我的订单】进行支付，支付后方等待招标代理机构核实，核实后可下载招标文件。</p>
                    `,
                },
                {
                    nav: "安装软件",
                    position: "top",
                    marginLeft: "115px",
                    imgUrl: "/images/help/d-download.png",
                    content: `
                    <h2>安装软件的注意事项：</h2>
                    <p>1、必须安装的软件：投标文件制作工具、河北CA工具包。</p>
                    <p>2、安装投标工具时，若提示没有找到源文件或拒绝访问，联系惠智采客服。</p>
                    <p>3、下载河北CA工具包时，若提示有病毒无法安装，联系400-707-3355。</p>
                    `,
                },
                {
                    nav: "编制投标文件",
                    position: "bottom",
                    marginLeft: "125px",
                    imgUrl: "/images/help/d-edit.png",
                    content: `
                    <h2>编制投标文件的注意事项：</h2>
                    <p>1、打开工具后先导入所投项目的.hzb格式招标文件，如果发布了澄清文件，投标人务必导入最新的.hzb格式澄清文件来制作。（补遗文件不影响制作流程）</p>
                    <p>2、导入.hzb招标文件时，如提示打开招标文件失败，请重新下载.hzb招标文件，注意下载的文件大小，要与页面提示的实际完整大小一致。</p>
                    <p>3、将线下做好的pdf格式标书，导入投标工具，根据左侧目录关联页码，插入CA后，投标文件正文上方会有签章按钮，可点击对投标正文进行签章。</p>
                    <p>4、关联页码是指将正文翻到与目录章节对应的那页，点击关联按钮；若内容为多页，只需关联对应章节的首页。</p>
                    <p>5、加密导出时，请务必确保电脑仅插入一个企业CA，不可同时插入个人CA。</p>
                    <p>6、加密导出后，生成的.htb格式加密文件登录网站递交，.txt格式开标密码请存好备用。</p>
                    <p>7、.htb加密文件无法打开进行查看，可通过投标工具，【打开已有】的.tbf过程文件进行检查。</p>
                    `,
                },
                {
                    nav: "缴纳技术服务费",
                    position: "top",
                    marginLeft: "125px",
                    imgUrl: "/images/help/d-pay.png",
                    content: `
                    <h2>缴纳技术服务费的注意事项：</h2>
                    <p>1、技术服务费为平台收取的使用费，在【我的购标项目】-进入流程【缴纳技术服务费】，默认是扫码支付，支持微信或支付宝。</p>
                    <p>2、缴纳时间只要不影响递交投标文件，任意时间均可缴纳。</p>
                    <p>3、开标后，登录惠智采-【业务订单】可申请发票。</p>
                    `,
                },
                {
                    nav: "递交投标文件",
                    position: "bottom",
                    marginLeft: "110px",
                    imgUrl: "/images/help/d-commit.png",
                    content: `
                    <h2>递交投标文件的注意事项：</h2>
                    <p><b>一、登录后—下载文件递交</b></p>
                    <p>1、【我的购标项目】-进入流程-【投标文件】。</p>
                    <p><b>二、特别注意></b></p>
                    <p>1、请先缴纳技术服务费，缴费后才可递交加密版投标文件。</p>
                    <p>2、上传文件时若提示上传出错，请更换网络环境。</p>
                    `,
                },
                {
                    nav: "开标解密",
                    position: "top",
                    marginLeft: "113px",
                    imgUrl: "/images/help/d-kb.png",
                    content: `
                    <h2>开标解密的注意事项：</h2>
                    <p>1、未到开标时间，进入开标大厅会显示开标倒计时（如图一），请您耐心等待。</p>
                    <p>2、已到开标时间，可正式进入开标大厅，开始解密（如图二）。</p>
                    <p>3、请在招标文件规定的解密时间段内完成解密，超时将无法解密。</p>
                    <p>4、若无法进入开标大厅，或点击CA解密按钮没反应，请及时更换为谷歌浏览器。</p>
                    <p>5、如使用密码解密，复制开标密码进行解密。</p>
                    `,
                },
                {
                    nav: "确认开标记录",
                    position: "bottom",
                    marginLeft: "110px",
                    imgUrl: "/images/help/d-kbjl.png",
                    content: `
                    <h2>确认开标记录的注意事项：</h2>
                    <p>1、开标大厅解密完后，待招标代理添加了开标记录，才可查看到开标记录的内容。</p>
                    <p>2、点击【开标记录】提示代理未添加开标记录，请稍后查看时，请您耐心等待。</p>
                    <p>3、点击【开标记录】能显示开标内容，若底部有【签名】按钮，可点击进行签名；若底部无【签名】按钮，仅需查看，无需签名。</p>
                    `,
                },
                {
                    nav: "澄清问题或二次报价",
                    position: "top",
                    marginLeft: "100px",
                    imgUrl: "/images/help/d-s2.png",
                    content: `
                    <h2>回复澄清问题或二次报价的注意事项：</h2>
                    <p>1、进入评标阶段后，如有需要回复澄清的问题，点击【我参与的项目】-进入流程-【解答评委疑问】进行回复。</p>
                    <p>2、如若进入流程中有【在线磋商/二次报价】节点，投标人可在此进行报价。</p>
                    <p>3、投标人解密完成后，需关注【我参与的项目】-进入流程-【评标】环节的节点。</p>
                    `,
                },
            ],
        };
    },
    computed: {
        currentDetail() {
            return this.list[this.current];
        },
    },
    methods: {
        tabClick(val) {
            this.current = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.help-line {
    background: url(/images/help/bg.png) no-repeat;
    padding: 80px 0;

    ::v-deep {
        h2 {
            font-size: 16px;
        }

        p {
            margin: 10px 0;
            line-height: 1.5em;
        }
    }

    .node {
        ul {
            overflow: hidden;
        }

        li {
            float: left;
            font-size: 16px;
            cursor: pointer;

            &:hover {
                color: #a55dbb;
            }

            &.cur {
                color: #a55dbb;
                font-weight: 600;
            }
        }
    }

    .detail {
        margin-top: 40px;

        .body {
            display: flex;
            min-height: 340px;

            .left {
                flex: 1;

                img {
                    display: block;
                    width: 100%;
                }
            }

            .right {
                flex: 1;
                margin-left: 30px;
            }
        }
    }
}
</style>
